import React, { useState } from "react";
import Link from "helpers/link";
import Slider from "react-slick";
import ogrLogo from "images/ogr_logo_black.png";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import "./index.scss";
import GoldRibbonBanner from "images/gold-ribbon-banner.png";
import GreenRibbonBanner from "images/green-ribbon-banner.png";
import { shopURL } from "utils/constants";

const RibbonBanner = ({ data, discipline }) => {
  const { style, message } = data;

  const layout = {
    "green": { image: GreenRibbonBanner, color: "text-[#DFAD26]" },
    "gold": { image: GoldRibbonBanner, color: "text-[#0D5448]" }
  }

  return (
    <div className={`flex w-full ${style ? "justify-between" : "justify-end"} absolute z-10 bottom-0 px-2 pb-2`}>
      {style && (
        <div className="relative flex justify-center items-center">
          <img src={layout[style]?.image} alt="ribbon" className="absolute w-full h-full z-0" />
          <p className={`z-10 relative text-xs pl-6 pr-11 font-semibold ${layout[style]?.color}`}> {message} </p>
        </div>
      )}
      {discipline && (
        <div className="rounded-3xl py-1 px-3 bg-[#0D5448]">
          <span className="text-gray-200 font-sans font-medium text-sm leading-6">
            {discipline} 
          </span>
        </div>
      )}
    </div>
  );
}

const HorseCard = ({ data }) => {
  const formatDate = (dateStr) => dateStr?.split("-").reverse().join(".");

  const {
    name,
    share_price,
    profile_image_url,
    horse_logo,
    description,
    cardDescription,
    slug,
    syndicate_end_date,
    available_shares,
    gender,
    discipline,
    trainers,
    cardImages,
    syndicateImage,
    horseState,
    bundleState,
    is_racing_club,
    horses
  } = data ?? {};

  // const [currentHorse, setCurrentHorse] = useState(bundle.horses[0]);
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // afterChange: (nextSlideIndex) => {
    //   setCurrentHorse(nextSlideIndex);
    // }
  };

  let availableShares = horses ? horses.reduce((minShares, horse) => horse.available_shares < minShares ? horse.available_shares : minShares, horses[0].available_shares) : available_shares;
  let sharePrice = horses ? horses.reduce((total, horse) => total + horse.price, 0) : share_price;
  let syndicateEndDate = horses ? horses.reduce((earliest, horse) => {
    let horseDate = new Date(horse.syndicate_end_date);
    return horseDate < earliest ? horseDate : earliest;
  }, new Date(horses[0].syndicate_end_date)).toISOString().split('T')[0] : syndicate_end_date;
  let state = horses ? bundleState : horseState;

  const horsesWithNoSyndicateTermEnd = ["the-club-horse"];

  const syndicateTermEnd = (is_racing_club || horsesWithNoSyndicateTermEnd.includes(slug)) ? 'Never' : formatDate(syndicateEndDate);

  const isHBB = slug === "the-club-horse";
  if (!data?.name || (sharePrice === undefined || sharePrice === null) || !data.slug) return <></>;

  const horseButtonLabels = {
    "fittocks-stud": "Register Interest",
    "jersey-rocs": "Register Interest",
    "spadestep": "Reserve Shares"
  }

  return (
    <div className="p-5 rounded-lg bg-white flex flex-col horse-card">
      <div className="relative rounded-md overflow-hidden">
        <Link to={horses ? `/bundles/${slug}` : `/horses/${slug}`}>
          <RibbonBanner data={{ style: data?.ribbonLayout, message: data?.ribbonMessage }} discipline={discipline} />
          <div className="w-full h-56 overflow-hidden">
            {cardImages?.length > 0 ? (
              <Slider
                {...settings}
                className="horse-card-slider"
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                }}
              >
                {cardImages.map((image, index) => (
                  <img key={index} src={image?.src} alt={image?.alt} />
                ))}
              </Slider>
            ) : (
              <img
                src={profile_image_url ? profile_image_url : ''}
                alt="horse"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </Link>
        {/* {discipline && (
          <div className="absolute right-3 bottom-2 rounded-3xl py-1 px-3 bg-green-900">
            <span className="text-gray-200 font-sans font-medium text-sm leading-6 ">
              {discipline} 
            </span>
          </div>
        )} */}
      </div>
      <div className="mt-5 flex-1 flex flex-col justify-between">
        <div>
              <div className="flex items-center justify-between">
                <p className="font-display text-h3 font-bold text-gray-800">
                  {name}
                </p>
                {
                  !horses && 
                  <img
                    src={syndicateImage?.src || horse_logo || ogrLogo}
                    alt="company"
                    className="max-w-[130px] max-h-11 object-contian"
                  />
                }
              </div>
              <div className="flex items-center gap-x-2.5">
              {!horses && trainers?.length > 0 && trainers.map(trainer => (
                  <AnchorLink
                    className="flex items-center justify-start mt-2"
                    to={`/trainers#${trainer?.name?.split(" ").join("_").toLowerCase()}`}
                  >
                    <img
                      src={trainer?.image?.src}
                      alt={trainer?.image?.alt}
                      className="w-5 h-5 rounded-full"
                    />
                    <h4 className="font-sans text-sm font-medium text-green-900 underline ml-2">
                      {trainer?.name}
                    </h4>
                  </AnchorLink>
                ))
              }
              </div>
          <div className="flex justify-start gap-8 mt-4">
            {syndicateEndDate && (
              <div>
                <h3 className="font-sans text-xs text-yellow-500">
                  Syndicate term ends
                </h3>
                <h4 className="font-sans font-bold text-sm text-gray-800 mt-1">
                  {syndicateTermEnd}
                </h4>
              </div>
            )}
            <div>
              <h3 className="font-sans text-xs text-yellow-500">{is_racing_club ? 'Membership' : horses ? 'Bundle Price' : 'Share price'}</h3>
              <h4 className="font-sans font-bold text-sm text-gray-800 mt-1">
                £{sharePrice} {is_racing_club && <span className="text-xs">per month</span>}
              </h4>
            </div>
            <div>
              <h3 className="font-sans text-xs text-yellow-500">{is_racing_club ? 'No.places' : horses ? 'No.bundles' : 'No.shares'}</h3>
              <h4 className="font-sans font-bold text-sm text-gray-800 mt-1">
                {availableShares < 100000 ? (
                  availableShares
                ) : (
                  <span className="text-2xl font-extrabold leading-none">
                    &#8734;
                  </span>
                )}
              </h4>
            </div>
          </div>
          <p className="my-4 font-sans text-sm text-gray-700 min-h-[60px]">
            {cardDescription || description?.substring(0, 150)}
          </p>
        </div>
        <div className="flex flex-col">
          <Link to={horses ? `/bundles/${slug}` : `/horses/${slug}`} className="btn btn-white">
            Learn More
          </Link>
          {state === "available" ? (
            <Link
              to={isHBB ? `/horses/${slug}` : is_racing_club ? 
                `${shopURL}/subscription/${slug}` 
                : horses ? 
                `${shopURL}/bundle/${slug}` 
                : `${shopURL}/${slug}`}
              className="btn btn-primary mt-4"
            >
              {slug === "the-club-horse" ? "Join The Club" : is_racing_club ? 'Buy Membership' : 'Become An Owner'}
            </Link>
          ) : (
            <AnchorLink
              to={horses ? `/bundles/${slug}#waiting_list` : `/horses/${slug}#waiting_list`}
              className="btn btn-primary mt-4"
            >         
              {slug === "the-hawkstonian" 
                ? "Join Waiting List" 
                : horseButtonLabels[slug] 
                  ? horseButtonLabels[slug] 
                  : state == "comming soon" 
                    ? "Reserve Shares" 
                    : "Join Waiting List"
              }
            </AnchorLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default HorseCard;
